// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "CommonDocs-module--hgwIcon-arrow-down--3Gh65";
export var hgwIconArrowUp = "CommonDocs-module--hgwIcon-arrow-up--2fVtq";
export var base = "CommonDocs-module--base--tCi-p";
export var profile = "CommonDocs-module--profile--6svCu";
export var animBarTypeA = "CommonDocs-module--animBarTypeA--341vq";
export var animBarTypeB = "CommonDocs-module--animBarTypeB--1serd";
export var animBarTypeC = "CommonDocs-module--animBarTypeC--3N26v";
export var animBarTypeD = "CommonDocs-module--animBarTypeD--BcofE";